/* Paw Chérie — OwnPrint customer-facing copy + safe PDP placement */

(function () {
  const isPawPrintProduct =
    window.location.pathname
      .replace(/\/+$/, '')
      .endsWith('/products/signature-paw-print-necklace') ||
    document.title.toLowerCase().includes('signature paw print necklace');
  function updateOwnPrintCopy() {
    const fields = document.querySelectorAll('.ownprint-personalization__field');

    fields.forEach((field) => {
      const label = field.querySelector('.ownprint-personalization__label');
      const instructions = field.querySelector(
        '.ownprint-personalization__instructions'
      );

      if (!label) return;

      const labelText = label.textContent.trim().toLowerCase();

      /* FINISH */
      if (labelText.includes('plating')) {
        label.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent.replace(/Plating/i, 'Finish');
          }
        });

        if (instructions) {
          instructions.textContent =
            'Choose the finish that feels most like them.';
        }
      }

            /* BACK ENGRAVING */
      if (
        labelText.includes('personalize the necklace on the back') ||
        labelText.includes('back engraving') ||
        labelText.includes('add a message on the back')
      ) {
        label.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = 'Add a Message on the Back ♡';
          }
        });

        if (instructions) {
          instructions.textContent =
            'Make it even more personal with a name, date, or message.';
        }

        /* LAUNCH GIFT */
        if (!field.querySelector('.paw-cherie-launch-engraving')) {
          const launchGift = document.createElement('div');
          launchGift.className = 'paw-cherie-launch-engraving';

          launchGift.innerHTML = `
            <strong>♡ Complimentary Back Engraving</strong>
            <span>Included for our first 50 orders.</span>
          `;

          field.appendChild(launchGift);
        }
      }

      /* PHOTO UPLOAD */
      if (
        labelText.includes("upload your pet’s photo") ||
        labelText.includes("upload your pet's photo") ||
        labelText.includes('upload their photo')
      ) {
        label.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent.replace(
              /Upload Your Pet[’']s Photo/i,
              isPawPrintProduct ? 'Upload Their Paw Print' : 'Upload Their Photo'
            );
          }
        });

        if (instructions) {
  instructions.textContent = isPawPrintProduct
  ? 'Upload a clear, well-lit photo or scan of the paw print impression.'
  : 'A clear, well-lit photo where their face is easy to see works best.';
}

        const hint = field.querySelector(
          '.ownprint-personalization__instructions--hint'
        );

        if (hint) {
          hint.textContent = isPawPrintProduct
            ? 'Upload a clear, well-lit photo or scan of the paw print impression.'
            : 'A clear, well-lit photo where their face is easy to see works best.';
        }
      }

      /* NAME UNDER DESIGN */
      if (
        labelText.includes('add their name under the portrait') ||
        labelText.includes('add their name under the paw print')
      ) {
        label.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = isPawPrintProduct
              ? 'Add Their Name Under the Paw Print ♡'
              : 'Add Their Name Under the Portrait ♡';
          }
        });
      }
    });
  }

  function placeOwnPrint() {
    const ownPrint = document.querySelector('.ownprint-personalization');
    const target = document.querySelector(
      '.paw-cherie-personalization-block'
    );

    if (!ownPrint || !target) {
      return false;
    }

    if (ownPrint.parentElement !== target) {
      target.appendChild(ownPrint);
    }

    return true;
  }

  function startPawCherieOwnPrint() {
    let attempts = 0;
    const maxAttempts = 20;

    const timer = setInterval(() => {
      attempts += 1;

      updateOwnPrintCopy();
      const placed = placeOwnPrint();

      if (placed || attempts >= maxAttempts) {
        clearInterval(timer);

        setTimeout(() => {
          updateOwnPrintCopy();
        }, 500);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPawCherieOwnPrint,
      { once: true }
    );
  } else {
    startPawCherieOwnPrint();
  }

  document.addEventListener('shopify:section:load', () => {
    startPawCherieOwnPrint();
  });
})();